// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-2ee80541] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n[data-v-2ee80541] .el-table th.blue-column {\n  background-color: #e5f6fd !important;\n}\n[data-v-2ee80541] .el-table th.yellow-column {\n  background-color: #fbe1be !important;\n}", ""]);
// Exports
module.exports = exports;
